(function () {
  function getMaxScroll(scrollEl) {
    return Math.max(0, scrollEl.scrollWidth - scrollEl.clientWidth);
  }

  function getScrollIncrement(scrollEl) {
    var steps = scrollEl.querySelectorAll('.b2b-workflow__step');
    if (steps.length >= 2) {
      var first = steps[0].getBoundingClientRect().left;
      var second = steps[1].getBoundingClientRect().left;
      var delta = second - first;
      if (delta > 0) return Math.round(delta);
    }

    if (steps[0]) {
      var list = steps[0].parentElement;
      var gap = 48;
      if (list) {
        var gapValue = getComputedStyle(list).columnGap || getComputedStyle(list).gap;
        if (gapValue) gap = parseFloat(gapValue) || gap;
      }
      return Math.round(steps[0].offsetWidth + gap);
    }

    return Math.round(scrollEl.clientWidth * 0.5);
  }

  function scrollToNextStep(scrollEl) {
    var maxScroll = getMaxScroll(scrollEl);
    if (maxScroll <= 1) return;

    var nextLeft = Math.min(
      scrollEl.scrollLeft + getScrollIncrement(scrollEl),
      maxScroll
    );

    scrollEl.scrollTo({
      left: nextLeft,
      behavior: 'smooth',
    });
  }

  function initWorkflowScroll() {
    document.querySelectorAll('[data-b2b-workflow-scroll]').forEach(function (scrollEl) {
      var timeline = scrollEl.closest('.b2b-workflow__timeline');
      var fill = timeline && timeline.querySelector('.b2b-workflow__progress-fill');
      var viewport = scrollEl.closest('.b2b-workflow__steps-viewport');
      var nextBtn =
        (viewport && viewport.querySelector('[data-b2b-workflow-scroll-next]')) ||
        scrollEl.querySelector('[data-b2b-workflow-scroll-next]');

      var defaultProgress =
        (timeline &&
          getComputedStyle(timeline).getPropertyValue('--progress').trim()) ||
        '85%';

      function updateScrollState() {
        var maxScroll = getMaxScroll(scrollEl);
        var atEnd = maxScroll <= 1 || scrollEl.scrollLeft >= maxScroll - 6;

        if (fill) {
          if (maxScroll <= 1) {
            fill.style.width = defaultProgress;
          } else {
            var scrolled = scrollEl.scrollLeft / maxScroll;
            var minPct = window.matchMedia('(max-width: 767px)').matches ? 23 : 18;
            var width = minPct + scrolled * (100 - minPct);
            fill.style.width = width + '%';
          }
        }

        if (viewport) {
          viewport.classList.toggle('is-at-end', atEnd);
        }

        if (nextBtn) {
          nextBtn.classList.toggle('is-hidden', atEnd);
          nextBtn.setAttribute('aria-hidden', atEnd ? 'true' : 'false');
        }
      }

      if (!scrollEl.dataset.bound) {
        scrollEl.dataset.bound = 'true';
        scrollEl.addEventListener('scroll', updateScrollState, { passive: true });
        window.addEventListener('resize', updateScrollState, { passive: true });
        window.addEventListener('load', updateScrollState, { passive: true });

        if (typeof ResizeObserver !== 'undefined') {
          var ro = new ResizeObserver(updateScrollState);
          ro.observe(scrollEl);
          var list = scrollEl.querySelector('.b2b-workflow__steps');
          if (list) ro.observe(list);
        }
      }

      if (nextBtn && !nextBtn.dataset.bound) {
        nextBtn.dataset.bound = 'true';
        nextBtn.addEventListener('click', function (event) {
          event.preventDefault();
          scrollToNextStep(scrollEl);
        });
      }

      updateScrollState();
      window.requestAnimationFrame(updateScrollState);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWorkflowScroll);
  } else {
    initWorkflowScroll();
  }

  document.addEventListener('shopify:section:load', initWorkflowScroll);
})();
